import { Pipe, PipeTransform } from '@angular/core';

/**
 * CKEditor 로 등록한 이미지의 상대경로(/uploads/... 또는 \uploads\...)를
 * 실제 파일 서버 주소(urlWownet)로 바꿔준다.
 * 외부 URL(http://, https://, //) 과 data URI 는 그대로 둔다.
 */
@Pipe({ name: "imgSrcPrefix" })
export class ImgSrcPrefixPipe implements PipeTransform {

  transform(value: any, urlWownet: any): string {
    if (!value) return '';
    if (!urlWownet) return value;

    const baseUrl = String(urlWownet).replace(/\/+$/, '');

    return String(value).replace(/(<img\b[^>]*?\bsrc\s*=\s*)(["'])(.*?)\2/gi, (match, prefix, quote, src) => {
      const url = String(src).trim();
      if (/^(https?:)?\/\//i.test(url) || /^data:/i.test(url)) return match;

      // 어드민(Windows) 에서 저장된 '\' 경로를 URL 형식 '/' 로 보정
      let path = url.replace(/\\/g, '/');
      if (!path.startsWith('/')) path = '/' + path;

      return prefix + quote + baseUrl + path + quote;
    });
  }
}
